<template>
  <div>
    <div class="fixed-message">
      <div class="message-header">
        <div class="title">消息</div>
        <div class="do-read" @click="readAll">一键已读</div>
      </div>
      <div class="message-content">
        <div v-if="lists && lists.length == 0" class="no-message">暂无消息</div>
        <div v-else v-loading="loading" class="message-list">
          <div v-for="(item, index) in lists" :key="item.id" class="item" :class="['item-' + index, item.un_read == 1 ? 'unread' : '']" @click="readMessage(item)">
            <div class="item-header">
              <div class="item-header-row v-row">
                <div class="name v-mr-5">{{ item.nickname }}</div>
                <div class="sub-title v-color-gray-lighter">
                  <span>{{ item.title }}</span>
                  <span v-if="item.msg_data.status" class="status" :style="{color:polylineInfo[item.msg_data.status].color}">
										{{polylineInfo[item.msg_data.status].text}}
									</span>
                </div>
                <div class="time v-ml-20">{{ item.create_time }}</div>
              </div>
              <el-popconfirm title="确认删除?" @onConfirm="deleteMessage(item)">
                <i slot="reference" @click.stop="" class="el-icon-delete" v-loading="item.deleteLoading"></i>
              </el-popconfirm>
            </div>
            <div class="content v-mt-5 v-ellipsis">{{ item.content }}</div>
          </div>
          <div v-if="last_page > page" class="load-more-btn v-mt-10" @click="getList(++page)">点击加载更多</div>
          <div v-if="page == last_page" class="no-more-data">没有更多数据了...</div>
        </div>
      </div>
    </div>
    <div class="mask" @click.stop="$emit('update:show', false)"></div>
    <comment-dialog v-if="isShowComment" :show.sync="isShowComment" :comment_id="comment_id.toString()" :view="true"></comment-dialog>
  </div>
</template>

<script>
import commentDialog from '@/pages/preview/components/comment-dialog';
import polylineInfo from '@/pages/preview/polyline'

export default {
  props: ['show'],

  components: { commentDialog },

  data() {
    return {
      lists: null,
			polylineInfo,
      loading: false,
      isShowComment: false,
      comment_id: '',
      page: 1,
      last_page: 1,
    };
  },

  created() {
    this.getList(1);
  },

  methods: {
    //获取消息
    async getList(page) {
      this.loading = true;
      this.page = page ? page : this.page;
      try {
        let res = await this.api.message.getMyMessage({ page: this.page });
        this.lists = this.page == 1 ? res.data.data : this.lists.concat(res.data.data);
        this.last_page = res.data.last_page;
        this.$emit('change', res.data.un_read_count);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //阅读消息
    async readMessage(row) {
      try {
        this.comment_id = row.msg_data.comment_reply_id;
        await this.api.comment.getReplyRow({ id: this.comment_id });
        this.isShowComment = true;
        await this.api.message.readMessage({ id: row.id });
        this.getList(1);
      } catch (e) {
        console.error(e);
      }
    },

    //一键已读
    async readAll() {
      try {
        await this.api.message.readAll();
        this.getList();
      } catch (e) {
        console.error(e);
      }
    },

    //删除消息
    async deleteMessage(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.message.delete({ id: row.id });
        this.$message.success('删除成功');
        this.getList(1);
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.fixed-message {
  position: fixed;
  top: 15vh;
  left: 50%;
  transform: translate(-50%, 0);
  background: #fff;
  width: 600px;
  border-radius: 4px;
  z-index: 21;
  color: #333;
  font-size: 14px;
}


.message-header {
  background: #f1f1f1;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-weight: bold;
  justify-content: space-between;
}

.message-content {
  display: flex;
  flex-direction: column;
  min-height: 100px;
}

.no-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #666;
}

.fixed-message .icon-bell {
  font-size: 20px;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  padding: 20px;
}

.message-list .item {
  padding: 20px;
  border: 1px solid #eee;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 10px;
  position: relative;
}

.message-list .item.unread:before {
  content: '';
  position: absolute;
  left: 10px;
  top: 28px;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background: red;
}

.message-list .item-0 {
  margin-top: 0;
}

.message-list .item .content {
  flex: 1;
}

.message-list .item .time {
  font-size: 12px;
  transform-origin: right center;
}

.item-header {
  display: flex;
  justify-content: space-between;
}

.item-header-row {
  display: flex;
  align-items: flex-start;
}
.item-header-row .sub-title {
  font-size: 13px;
}
.item-header-row .status {
  color: #2395f1;
  margin-left: 3px;
}

.do-read {
  cursor: pointer;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: rgba(0, 0, 0, 0.5);
}
.comment-dialog {
  z-index: 30;
}
.load-more-btn {
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  background: #f8f8f8;
  font-size: 13px;
  cursor: pointer;
}
.no-more-data {
  display: flex;
  height: 30px;
  font-size: 12px;
  padding-top: 20px;
  color: #999;
  justify-content: center;
  align-items: center;
}
</style>
